export enum WalletType {
  MYALGO = 'myalgo',
  METAMASK = 'metamask'
}
